module.exports = {
  title: 'Scroll Transition with Reanimated and Skia',
  author: 'Enzo Manuel Mangano',
  date: '2024-02-21',
  slug: '3d-scroll-transition',
  tags: ['reanimated', 'skia'],
};
